import { IUseBoolean } from "hooks/use-boolean/use-boolean.types";
import React from "react";
import { IPrimaryUser } from "services/api/api.types";
import { SubscriptionStatus } from "services/api/sessions/sessionService.types";

export type ITrialActivationModal = {
  onClose: () => void;
  primaryUser?: IPrimaryUser;
  subscriptionStatus?: SubscriptionStatus;
};

export type IKelasLiveFeaturesData = {
  imgSrc: React.FC;
  alt: string;
  title: string;
  desc: string;
};

export enum TrialActivationState {
  TRIAL_ACTIVATED = "trial_activated",
  TRIAL_EXPIRED = "trial_expired",
  TRIAL_ACTIVE = "trial_active",
  PAID_EXPIRED = "paid_expired"
}

export type IUseTrialActivationModal = {
  activationState: TrialActivationState | null;
  setActivationState: (activationState: TrialActivationState | null) => void;
  isActivating: boolean;
  activateTrial: () => void;
  closeTrialModal: () => void;
  showTrialActivationComponent: TrialActivationComponent;
  setShowTrialActivationComponent: (
    showTrialActivationComponent: TrialActivationComponent
  ) => void;
  handleActivationStates: (activationState: TrialActivationState) => void;
  showTrialActivation: boolean;
  setShowTrialActivation: IUseBoolean;
};

export type ITrialActivationMessage = {
  onClose: () => void;
  activateTrial: () => void;
};

export type ITrialActivationStatus = {
  activationState: TrialActivationState;
  onClose: () => void;
  daysLeft: number | null | undefined;
};

export enum TrialActivationComponent {
  TRIAL_ACTIVATION_MESSAGE = "trial_activation_message",
  TRIAL_ACTIVATION_STATUS = "trial_activation_status"
}
